import { render } from "./HelpView.vue?vue&type=template&id=45d924bc"
import script from "./HelpView.vue?vue&type=script&lang=js"
export * from "./HelpView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__